import useAuth from "../../Hooks/useAuth";
import {
  useLazyGetMyActivityQuery,
  useGetMyActivityDetailQuery,
  useLazyGetDealerRolesMyActivityQuery,
  useGetDealerRolesMyActivityDetailQuery,
} from "../../store";

const PANEL_ROLES = ["admin", "storage", "dealer"];

/**
 * Son İşlemler (#412) — rol grubuna göre doğru uç. Merkez (admin/storage)
 * storageRoles, bayi dealerRoles dilimini kullanır; öteki grubun ucuna HİÇ
 * istek gitmez (lazy tetikleyiciler çağrılmadıkça istek atmaz, detay sorgusu
 * rol dışında `skip`).
 */
export default function useMyActivityApi() {
  const { auth } = useAuth();
  const isDealer = auth?.role === "dealer";
  const [storageFetch] = useLazyGetMyActivityQuery();
  const [dealerFetch] = useLazyGetDealerRolesMyActivityQuery();
  return {
    enabled: !!auth?.accessToken && PANEL_ROLES.includes(auth?.role),
    token: auth?.accessToken,
    isDealer,
    // Kullanıcı değişince Son İşlemler listesi sıfırlansın (#308)
    userKey: auth?._id || auth?.email || null,
    fetchPage: isDealer ? dealerFetch : storageFetch,
  };
}

/** Çekmece detayı — yalnız açıkken ve yalnız kullanıcının rol grubunun ucuna */
export function useMyActivityDetail(id) {
  const { auth } = useAuth();
  const isDealer = auth?.role === "dealer";
  const token = auth?.accessToken;
  const args = { token, id };
  const storage = useGetMyActivityDetailQuery(args, { skip: !id || !token || isDealer });
  const dealer = useGetDealerRolesMyActivityDetailQuery(args, { skip: !id || !token || !isDealer });
  return isDealer ? dealer : storage;
}
